module.exports = __webpack_public_path__ + "static/img/0541_6.929118d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_6.jpg
// module id = M9AD
// module chunks = 1